import React from 'react';
import { Box, SelectComponent } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { CardOrderBenefitTypes } from '@epi-constants/cardOrderHistoryBenefitTypes';

interface CardOrderSelectRangeProps {
  cardTypeId?: string;
  setCardTypeId: (type: string) => void;
  setPage: (page: number) => void;
}

export const CardTypeSelectionRange = ({
  cardTypeId,
  setCardTypeId,
  setPage
}: CardOrderSelectRangeProps) => {
  const { t } = useTranslation();

  const options = CardOrderBenefitTypes.map((card: string) => ({
    display: t(`containers.deposit_money.card_orders_tab.card_type.${card}`),
    id: card
  }));

  const handleChange = value => {
    setCardTypeId(value.id);
    setPage(1);
  };

  return (
    <Box>
      <SelectComponent
        label=""
        placeholder={t`containers.deposit_money.card_orders_tab.card_type.placeholder`}
        id="card-type-select"
        selectedId={cardTypeId}
        options={options}
        onChange={handleChange}
      />
    </Box>
  );
};
